import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { FormField } from '@/shared/components/form';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Resolves true when the rejection went through; the dialog then closes. */
  onConfirm: (comment: string) => Promise<boolean>;
  pending: boolean;
}

export function RejectDialog({ open, onOpenChange, onConfirm, pending }: Props) {
  const { t } = useTranslation('crm');
  const [comment, setComment] = useState('');
  const close = () => { setComment(''); onOpenChange(false); };
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) close(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('estimates.reject.title')}</DialogTitle>
          <DialogDescription>{t('estimates.reject.description')}</DialogDescription>
        </DialogHeader>
        <FormField label={t('estimates.reject.comment')} htmlFor="est-reject-comment" required>
          <Textarea id="est-reject-comment" rows={4} maxLength={2000} value={comment} onChange={(e) => setComment(e.target.value)} />
        </FormField>
        <DialogFooter>
          <Button variant="outline" onClick={close}>{t('estimates.actions.cancel')}</Button>
          <Button
            variant="destructive"
            disabled={!comment.trim() || pending}
            onClick={async () => { if (await onConfirm(comment.trim())) close(); }}
          >
            {t('estimates.reject.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
